
import React from "react";
import { useEffect, useState, useRef } from 'react'
import { INDUSTRIES, CLIENTTYPE } from "./OrgDataCollections";
import { updateValueWeight } from "../../utils/api";

import Rodal from "rodal";
import { useNavigate } from "react-router-dom";
import { listCompanies } from "../../utils/api";

import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import FormInput from "../../components/FormInput";
import FormTextArea from "../../components/FormTextArea";
import { ValueMetaDataSchema } from "../../schemas/InterviewBuilder";

export function ToolTipModal(props) {
    const {headerText, bodyText, styleTop, styleLeft, buttonRef, modalRef, showModalTip, modalType, onClose} = props;

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (buttonRef.current && !buttonRef.current.contains(event.target) &&
          modalRef.current && !modalRef.current.contains(event.target)) {
            showModalTip(false);
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [buttonRef, modalRef]);

      const [tooltipStyle, setTooltipStyle] = useState({
        position: "fixed",
        zIndex: 999,
        width: 12,
        height: 7,
        bottom: 0,
        left: 0,
    });

    useEffect(() => {
        if (modalRef.current) {
            const modalRect = modalRef.current.getBoundingClientRect();

            setTooltipStyle({
                ...tooltipStyle,
                top: styleTop + modalRect.height, // Position the tooltip at the bottom of the modal
                left: styleLeft + modalRect.width / 4 - 60, // Center the tooltip horizontally
            });
        }
    }, [modalRef, styleTop, styleLeft]);

    const styles = {
        mainContainer: {
            borderRadius: 24,
            background: "var(--White-White, #FFF)",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.40)",
            display: "flex",
            padding: "8px 8px 24px 8px",
            flexDirection: "column",
            alignItems: "start",
            gap: 16,
            position: "absolute",
            top: styleTop,
            left: styleLeft,
            width: 402,
            zIndex: modalType === 'valueweighttooltip' ? 9990 : 3,
            maxHeight: 524,
        },

        header : {
            display: "flex",
            width: 386,
            height : 40,
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 200,
            background: "linear-gradient(90deg, #F60 0%, #F59E0B 100%)",
            padding : 8
        },
        headerText : {
            color: "var(--White-White, #FFF)",
    
            /* Body Medium/SemiBold */
            fontFamily: "Inter",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 600,
            marginLeft: 8
        },
        tipModal: {
            position: "fixed",
            top: modalType === "tooltip" ? styleTop - 6 : modalType === "companyValuesModalTip" ? styleTop - 6 : modalType === "industry" ? styleTop + 193 : styleTop + 277,
            left:  modalType === "tooltip" ? styleLeft + 137 : modalType === "clientType" ? styleLeft + 107 : styleLeft + 105,
            zIndex: 999,
            width: 12,
            height: 7,
        },
        onboardingTipModal : {
            position : "fixed",
            zIndex: 999,
            width: 7,
            height: 12,
            top : styleTop + 85,
            left : styleLeft - 7,
        },
        onboardingTipTwo : {
            position : "fixed",
            zIndex: 999,
            width: 12,
            height: 7,
            top : styleTop - 7,
            left : styleLeft + 185,
        },
        valuModalInfoTip : {
            position : "fixed",
            zIndex: 9999,
            width: 12,
            height: 7,
            bottom : styleTop,
            left : styleLeft,
        },
        valueWeightModal : {

        },
        valueWeightToolTip : {
            position : "fixed",
            zIndex: 999,
            width: 12,
            height: 7,
            top : styleTop + 210,
            left : styleLeft + 195,
        },
        publishWarningToolTip : {
            position : "fixed",
            zIndex: 999,
            top : styleTop + 72,
            left : styleLeft + 402,
        }
    }

    function renderHeader() {
        return (
            <div style={styles.header}>
                <div style={{display : "flex"}}>
                    <div className="modal-info-icon-black"></div>
                    <div style={styles.headerText}>{headerText}</div>
                </div>
                <button className="modal-close-icon"
                    onClick={() => showModalTip(false)}
                />
            </div>
        )
    }

    function renderBody() {
        return (
            <div style={{paddingLeft: 16, paddingRight : 16, overflow: "scroll"}}>
                <div>{bodyText}</div>
            </div>
        )
    }

    return(
        <div style={styles.mainContainer} ref={modalRef}>
            {modalType === "companyValuesModalTip" && (
                <div className="modal-tip-upward" style={styles.tipModal}></div>
            )}
            {modalType === "industry" &&  (
                <div className="modal-tip" style={styles.tipModal}></div>
            )}
            {modalType === "clientType" && (
                <div className="modal-tip" style={styles.tipModal}></div>
            )}
            {modalType === "tooltip" && (
                <div className="modal-tip-upward" style={styles.tipModal}></div>
            )}
            {modalType === "onboardingtipone" && (
                <div className="modal-tip-left" style={styles.onboardingTipModal}></div>
            )}
            {modalType === "onboardingtiptwo" && (
                <div className="modal-tip-upward" style={styles.onboardingTipTwo}></div>
            )}
            {modalType === "valueModalInfo" &&  (
                <>
                <div className="modal-tip" style={tooltipStyle}></div>
                </>
            )}
            {modalType === "valueweighttooltip" &&  (
                <div className="modal-tip" style={styles.valueWeightToolTip}></div>
            )}
            {modalType === "publishwarninig" &&  (
                <div className="tip-right" style={styles.publishWarningToolTip}></div>
            )}
            {renderHeader()}
            {renderBody()}
        </div>
    )
}

export function CompanyValuesAndBehaviorModal(props) {

    const { modalVisible, onClose, title, setValueTitle, setValueDescription, setShowOnboardingCompanyValuesModal, mode, setMode, valueSelected, setValueSelected } = props

    const [styleTop, setStyleTop] = useState(null);
    const [styleLeft, setStyleLeft] = useState(null);
    const tipBtnRef = useRef(null);
    const modalTipRef = useRef(null);

    const [showTipModal, setShowTipModal] = useState(false)
    const [canContinue, setCanContinue ] = useState(false)

    const [valueSelectedTitle, setValueSelectedTitle] = useState("")
    const [valueSelectedDescription, setValueSelectedDescription] = useState("")
    const [valueSelectedForEdit, setValueSelectedForEdit] = useState(null)
    const { control, handleSubmit, formState: { errors }, register, getValues, setValue, trigger, reset } = useForm({
        resolver: yupResolver(ValueMetaDataSchema),
        mode: "onSubmit",
        defaultValues: {
            title: "",
            description: "",
            weight: 0,
        },
    });

    const handleUpdateTitle = (e) => {
        setValue('title', e.target.value, { shouldValidate: true, shouldDirty: true });
        trigger('title')
    }

    const handleUpdateDescription = (e) => {
        setValue('description', e.target.value, { shouldValidate: true, shouldDirty: true });
        trigger('description')
    }

    const onSubmit = () => {
    }

    useEffect(() => {
        setStyleTop(null)
        setStyleLeft(null)
        if (showTipModal && tipBtnRef.current && modalTipRef.current) {
     
            const btnRect = tipBtnRef.current.getBoundingClientRect();
            const modalTop = 58;
            const modalLeft =  354;

            setStyleTop(modalTop)
            setStyleLeft(modalLeft)
          }
    }, [showTipModal]);

    useEffect(() => {
        setValueSelectedForEdit(valueSelected)
        setValueSelectedTitle(valueSelected?.title)
        setValueSelectedDescription(valueSelected?.description)
    },[valueSelected])
    
    const styles = {
        modal: {
            display: "flex",
            flexDirection: "column",
            height: 450,
            bottom: "50%",
            top: "50%",
            padding: 0,
            borderRadius: 24,
            overflow: "hidden",
            width: 904,
            flexShrink: 0
        },
        modalWrapper: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
        },
        headerWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 24,
        },
        headerText: {
            color: "var(--Primary-Text, #374151)",

            /* Heading 6 */
            fontFamily: "Inter",
            fontSize: 24,
            fontStyle: "normal",
            fontWeight: 700
        },
        groupFlex : {
            display: "flex", 
            alignItems: "center"
        },
        nextButton :{
            borderRadius: 50,
            background: "var(--Primary, #F60)",
            color: "#FFF",
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
        },
        cancelButton : {
            borderRadius: 50,
            border: "1px solid var(--Stroke, #DFE4EA)",
            background: "var(--White-White, #FFF)",
            marginLeft: 8,
            height : 40,
            width: 88
        },
        bodyContainer :  {
            borderRadius: 24,
            background: "var(--Gray-Gray-2, #F3F4F6)",
            padding: 8,
            width: 906,
            height: "100vh"
        },
        bodyInsideContainer : {
            background : "var(--White-White, #FFF)",
            borderRadius: 24,
            width: 888,
            height: 315,
            padding: 24
        },
        itemTextTitle : {
            color: "var(--Primary-Text, #374151)",

            /* Body Medium/Medium */
            fontFamily: "Inter",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 500,
            marginBottom: 8
        }

    }

    const handleNextButtonClicked = () => {
        const {title, description} = getValues()
        if (title && description){
            setCanContinue(true)
            setValueSelected({...valueSelected, title: title, description: description})
            setMode(mode)
            setShowOnboardingCompanyValuesModal(true)
            setValueTitle(null)
            setValueDescription(null)
            reset()
            onClose()
        }
    }

    return (
        <Rodal
            visible={props.modalVisible}
            onClose={props.onClose}
            customStyles={{ ...styles.modal, ...props.style }}
            duration={0}
            showCloseButton={false}
            className="overflow-auto"
        >
        <div style={styles.modalWrapper}>

            <FormProvider {...{ control, errors, register }}>
                <form style={styles.bodyInsideContainer} onSubmit={handleSubmit(onSubmit)}>
                    {renderHeader()}
                    {renderBody()}
                    {showTipModal && <ToolTipModal 
                            headerText="Company Value & Behaviors"
                            bodyText={
                                <>
                                Each value describes a foundational operating principle, as well as the associated behaviors 
                                that have become norms and established practices.
                                </>
                            }
                            modalRef={modalTipRef} 
                            buttonRef={tipBtnRef}
                            styleTop={styleTop}
                            styleLeft={styleLeft}
                            showModalTip={setShowTipModal}
                            modalType="tooltip"
                    />}
                </form>
            </FormProvider>
        </div>
        </Rodal>
    );

    function renderHeader() {
        return (
            <div style={styles.headerWrapper}>
                <div style={styles.groupFlex}>
                    <div style={styles.headerText}>{title}</div>
                    <button className="help-icon"
                        onMouseEnter={() => setShowTipModal(true)}
                        ref={tipBtnRef}
                    ></button>
                </div>
                <div style={styles.groupFlex}>
                    <button style={styles.nextButton}
                        onClick={() => handleNextButtonClicked()}
                        type="submit"
                    >
                        <div className="arrow-forward_white"></div>
                        <div>Next</div>
                    </button>
                    <button style={styles.cancelButton}
                        onClick={() => onClose()}
                    >Cancel</button>
                </div>
            </div>
        )
    }
    function renderBody() {
        return (
            <div style={styles.bodyContainer}>
                <div style={styles.bodyInsideContainer}>
                    <div>
                        <FormInput field={`title`} errors={errors.title} register={register} label="Value Title" onChange={handleUpdateTitle} />
                    </div>
                    <div>
                        <FormTextArea field={`description`} errors={errors.description} register={register} label="Description" height={152} onChange={handleUpdateDescription} />
                    </div>
                </div>
            </div>
        )
    }
}

export function DeleteModal(props) {
    const {onProceed, onCancel, modalVisible, bodyText} = props

    const styles = {
        modal: {
            display: "flex",
            flexDirection: "column",
            bottom: "50%",
            top: "50%",
            padding: 0,
            borderRadius: 24,
            overflow: "hidden",
            width: 480,
            flexShrink: 0
        },
        modalWrapper: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
        },
        headerWrapper: {
            padding: 24,
        },
        headerText: {
            color: "var(--Primary-Text, #374151)",

            /* Heading 6 */
            fontFamily: "Inter",
            fontSize: 24,
            fontStyle: "normal",
            fontWeight: 700
        },
        divider : {
            background: "var(--Stroke, #DFE4EA)",
            width : "100%",
            height : 1,
            marginTop : 16
        },
        bodyText : {
            color: "var(--Secondary-Text, #6B7280)",

            /* Body Medium/Regular */
            fontFamily: "Inter",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 400,
            marginBottom : 40
        },
        groupFlex : {
            display: "flex", 
            alignItems: "center",
        },
        yesButton : {
            borderRadius: 50,
            background:" var(--Primary, #F60)",
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
            marginRight : 8,
            color : "var(--White-White, #FFF)",
        },
        cancelButton : {
            borderRadius: 50,
            border: "1px solid var(--Stroke, #DFE4EA)",
            background: "var(--White-White, #FFF)",
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
        }
    }

    function renderHeader() {
        return (
            <div style={styles.headerWrapper}>
                <div style={styles.headerText}>Delete</div>
                <div style={styles.divider}></div>
            </div>
        )
    }

    function renderBody() {
        return(
            <div style={{paddingLeft : 24, paddingRight : 24, marginBotton : 24}}>
                <div style={styles.bodyText}>
                    {bodyText}
                </div>
                <div style={styles.groupFlex}>
                    <button style={styles.yesButton}
                        onClick={onProceed}
                    >
                        <div className="check-circle-outline"></div>
                        <div style={{marginLeft : 8}}>Yes</div>
                    </button>
                    <button style={styles.cancelButton}
                        onClick={onCancel}
                    >
                        <div>Cancel</div>
                    </button>
                </div>
            </div>
            
        )
    }
    return (
        <Rodal
            visible={props.modalVisible}
            onClose={props.onClose}
            customStyles={{ ...styles.modal, ...props.style }}
            duration={0}
            showCloseButton={false}
        >
        <div style={styles.modalWrapper}>
            {renderHeader()}
            {renderBody()}
        </div>
        </Rodal>
    );

}

export function StatusModal (props) {

    const {showModal, onClose, headerText, statusText, status} = props;
    const [progress, setProgress] = useState(0);

    const styles = {
        rodalContainer: {
            height: 80,
            backgroundColor: "transparent"
        },
        progressContainer: {
            zIndex: 999,
            position: "absolute",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            height: 80,
            width: "auto",
            padding: 8,
            borderRadius: 16,
            border: "1px solid var(--Stroke, #DFE4EA)",
            background: "var(--White-White, #FFF)",
    
            /* Shadow 1 */
            boxShadow: "0px 1px 3px 0px rgba(166, 175, 195, 0.40)"
        },
        uploadIconContainer: {
            display: "flex",
            padding: 8,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            background: status === "success" ? "var(--Green-Green-light-6, #DAF8E6)" : "var(--Red-Red-light-6, #FEE2E2)",
            height: 64,
            width: 64,
        },
        statusContainer: {
            marginLeft: 16,
            widht: "auto",
            height: 64,
            alignItems: "center",
            display: "inline-grid",
            justifyContent: "center",
        },
        uploadingText: {
            color: status === "success" ? "var(--Green-Green-dark, #1A8245)" : "var(--Red-Red-dark, #C53030)",
            width: 350,
            /* Body Large/SemiBold */
            fontFamily: "Inter",
            fontSize: 18,
            fontStyle: "normal",
            fontWeight: 600
        },
        statusText: {
            color: "var(--Secondary-Text, #6B7280)",
            width: 'auto',
            /* Body Large/SemiBold */
            fontFamily: "Inter",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: 400
        },
    }
    return (
        <div style={{position: "fixed", top: 32, left: "36%", alignSelf: "center", zIndex: 9999}}>
            <div style={styles.progressContainer}>
                <div style={styles.uploadIconContainer}>
                    {status === "success" ? (
                        <div className="check-icon"></div>
                    ) : (
                        <div className="error-outline"></div>
                    )}
                </div>
                <div style={styles.statusContainer}>
                    <label style={styles.uploadingText}>{headerText}</label>
                    <label style={styles.statusText}>{statusText}</label>
                </div>
            </div>
        </div>
    );
}

export function SelectIndustryModal (props) {

    const { title, onClose, modalVisible, selectedIndustries, setSelectedIndustries} = props;

    const [canContinue, setCanContinue ] = useState(false)

    const [currentSelectedIndustries, setCurrentSelectedIndustries] = useState([])

    useEffect(() => {
        if(currentSelectedIndustries?.length > 0){
            setCanContinue(true)
        }
        else {
            setCanContinue(false)
        }
    },[currentSelectedIndustries])

    useEffect(() => {
        setCurrentSelectedIndustries(
            selectedIndustries?.filter(type => type.id !== '' && type.name !== '')
        );
    }, [selectedIndustries]);

    const handleSelectButtonClick = (index) => {
        const industry = INDUSTRIES[index];
       
        setCurrentSelectedIndustries(prevSelectedIndustries => {
            if (prevSelectedIndustries.includes(industry)) {
                return prevSelectedIndustries.filter(type => type !== industry);
            } else {
                return [...prevSelectedIndustries, industry];
            }
        });
    };

    function handleSaveButtonClicked() {
        setSelectedIndustries(prevSelectedIndustries => {
            const filteredSelectedIndustries = prevSelectedIndustries.filter(
                type => !(type.id === '' && type.name === '')
            );

            const updatedIndustries = [
                ...filteredSelectedIndustries,
                ...currentSelectedIndustries.filter(
                    type => !filteredSelectedIndustries.includes(type)
                )
            ];
            const defaultItem = { id: '', name: '' };
            return [...updatedIndustries, defaultItem];
        });
        onClose();
    }

    const styles = {
        modal: {
            display: "flex",
            flexDirection: "column",
            height: 520,
            bottom: "50%",
            top: "50%",
            padding: 0,
            borderRadius: 24,
            overflow: "hidden",
            width: 717,
            flexShrink: 0
        },
        modalWrapper: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
        },
        headerWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 24,
        },
        headerText: {
            color: "var(--Primary-Text, #374151)",

            /* Heading 6 */
            fontFamily: "Inter",
            fontSize: 24,
            fontStyle: "normal",
            fontWeight: 700
        },
        groupFlex : {
            display: "flex", 
            alignItems: "center"
        },
        nextButton :{
            borderRadius: 50,
            background: canContinue ? "var(--Primary, #F60)" : "var(--Stroke, #DFE4EA)",
            color: canContinue ? "#FFF" : "#9CA3AF",
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
        },
        cancelButton : {
            borderRadius: 50,
            border: "1px solid var(--Stroke, #DFE4EA)",
            background: "var(--White-White, #FFF)",
            marginLeft: 8,
            height : 40,
            width: 88
        },
        bodyContainer :  {
            borderRadius: 24,
            background: "var(--Gray-Gray-2, #F3F4F6)",
            padding: 8,
            width: 717,
            height: "100vh"
        },
        bodyInsideContainer : {
            background : "var(--White-White, #FFF)",
            borderRadius: 24,
            width: 701,
            height: 416,
            paddingTop : 8,
            paddingLeft: 16,
            paddingRight: 16
        },
        contentContainer : {
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: 701,
            height: 398
        },
        itemTextTitle : {
            color: "var(--Primary-Text, #374151)",

            /* Body Medium/Medium */
            fontFamily: "Inter",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 500,
            marginBottom: 8
        },
        industryItem: {
            flex: '1 1 50%',
            display: 'flex',
            alignItems: 'center',
            padding: 8,
        },
        industryItemCheckButton : {
            borderRadius: 4,
            border: "1px solid var(--Stroke, #DFE4EA)",
            backgroundColor: "var(--White-White, #FFF)",
            width: 24,
            height: 24,
            marginRight: 8
        },
        industryItemCheckButtonActive : {
            borderRadius: 4,
            backgroundColor: "var(--Secondary, #0074D9)",
            width: 24,
            height: 24,
            marginRight: 8
        }

    }
    return (
        <Rodal
            visible={props.modalVisible}
            onClose={props.onClose}
            customStyles={{ ...styles.modal, ...props.style }}
            duration={0}
            showCloseButton={false}
        >
        <div style={styles.modalWrapper}>
            {renderHeader()}
            {renderBody()}
        </div>
        </Rodal>
    );
    function renderHeader() {
        return (
            <div style={styles.headerWrapper}>
                <div style={styles.groupFlex}>
                    <div style={styles.headerText}>{title}</div>
                </div>
                <div style={styles.groupFlex}>
                    <button style={styles.nextButton}
                        onClick={() => handleSaveButtonClicked()}
                    >
                        {canContinue ? <div className="save-icon-active"></div> : <div className="save-icon-disable"></div>}
                        <div>Save</div>
                    </button>
                    <button style={styles.cancelButton}
                        onClick={() => onClose()}
                    >Cancel</button>
                </div>
            </div>
        )
    }
    function renderBody() {
        return (
            <div style={styles.bodyContainer}>
                <div style={styles.bodyInsideContainer}>
                    <div style={styles.contentContainer}>
                        {INDUSTRIES.map((industry, index) => (
                            <div key={index} style={styles.industryItem}>
                                <button 
                                 style={currentSelectedIndustries?.includes(industry) ? styles.industryItemCheckButtonActive : styles.industryItemCheckButton}
                                 onClick={() => handleSelectButtonClick(index)}
                                 className={currentSelectedIndustries?.includes(industry) ? "check" : ""}>

                                </button>
                                <label htmlFor={`industry-${index}`}>{industry.name}</label>
                            </div>
                        ))}
                    </div>
                    
                </div>
            </div>
        )
    }
}

export function SelectClientTypeModal (props) {

    const { title, onClose, modalVisible, setSelectedClientType, selectedClientType } = props;

    const [canContinue, setCanContinue ] = useState(false)
    const [currentSelectedClientTypes, setCurrentSelectedClientTypes] = useState([])

    useEffect(() => {
        if(currentSelectedClientTypes?.length > 0){
            setCanContinue(true)
        }
        else {
            setCanContinue(false)
        }
    },[currentSelectedClientTypes])

    useEffect(() => {
        setCurrentSelectedClientTypes(
            selectedClientType?.filter(type => type.id !== '' && type.name !== '')
        );
    }, [selectedClientType]);

    const handleSelectButtonClick = (index) => {
        const clientType = CLIENTTYPE[index];
       
        setCurrentSelectedClientTypes(prevSelectedClientType => {
            if (prevSelectedClientType.includes(clientType)) {
                return prevSelectedClientType.filter(type => type !== clientType);
            } else {
                return [...prevSelectedClientType, clientType];
            }
        });
    };

    function handleSaveButtonClicked() {
        setSelectedClientType(prevSelectedClientType => {
            const filteredSelectedClientTypes = prevSelectedClientType.filter(
                type => !(type.id === '' && type.name === '')
            );

            const updatedClientTypes = [
                ...filteredSelectedClientTypes,
                ...currentSelectedClientTypes.filter(
                    type => !filteredSelectedClientTypes.includes(type)
                )
            ];
            const defaultItem = { id: '', name: '' };
            return [...updatedClientTypes, defaultItem];
        });
        onClose();
    }
    

    const styles = {
        modal: {
            display: "flex",
            flexDirection: "column",
            height: 520,
            bottom: "50%",
            top: "50%",
            padding: 0,
            borderRadius: 24,
            overflow: "hidden",
            width: 904,
            flexShrink: 0
        },
        modalWrapper: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
        },
        headerWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 24,
        },
        headerText: {
            color: "var(--Primary-Text, #374151)",

            /* Heading 6 */
            fontFamily: "Inter",
            fontSize: 24,
            fontStyle: "normal",
            fontWeight: 700
        },
        groupFlex : {
            display: "flex", 
            alignItems: "center"
        },
        saveButton :{
            borderRadius: 50,
            background: canContinue ? "var(--Primary, #F60)" : "var(--Stroke, #DFE4EA)",
            color: canContinue ? "#FFF" : "#9CA3AF",
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
        },
        cancelButton : {
            borderRadius: 50,
            border: "1px solid var(--Stroke, #DFE4EA)",
            background: "var(--White-White, #FFF)",
            marginLeft: 8,
            height : 40,
            width: 88
        },
        bodyContainer :  {
            borderRadius: 24,
            background: "var(--Gray-Gray-2, #F3F4F6)",
            padding: 8,
            width: 908,
            height: "100vh"
        },
        bodyInsideContainer : {
            background : "var(--White-White, #FFF)",
            borderRadius: 24,
            width: 888,
            height: 416,
            paddingTop : 8,
            paddingLeft: 16,
            paddingRight: 16
        },
        contentContainer : {
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: 888,
            height: 398
        },
        itemTextTitle : {
            color: "var(--Primary-Text, #374151)",

            /* Body Medium/Medium */
            fontFamily: "Inter",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 500,
            marginBottom: 8
        },
        clientTypeItem: {
            flex: '1 1 50%',
            display: 'flex',
            alignItems: 'center',
            padding: 8,
        },
        clientTypeItemCheckButton : {
            borderRadius: 4,
            border: "1px solid var(--Stroke, #DFE4EA)",
            backgroundColor: "var(--White-White, #FFF)",
            width: 24,
            height: 24,
            marginRight: 8
        },
        clientTypeItemCheckButtonActive : {
            borderRadius: 4,
            backgroundColor: "var(--Secondary, #0074D9)",
            width: 24,
            height: 24,
            marginRight: 8
        }

    }
    return (
        <Rodal
            visible={props.modalVisible}
            onClose={props.onClose}
            customStyles={{ ...styles.modal, ...props.style }}
            duration={0}
            showCloseButton={false}
        >
        <div style={styles.modalWrapper}>
            {renderHeader()}
            {renderBody()}
        </div>
        </Rodal>
    );
    function renderHeader() {
        return (
            <div style={styles.headerWrapper}>
                <div style={styles.groupFlex}>
                    <div style={styles.headerText}>{title}</div>
                </div>
                <div style={styles.groupFlex}>
                    <button style={styles.saveButton}
                        onClick={() => handleSaveButtonClicked()}
                    >
                        {canContinue ? <div className="save-icon-active"></div> : <div className="save-icon-disable"></div>}
                        <div>Save</div>
                    </button>
                    <button style={styles.cancelButton}
                        onClick={() => onClose()}
                    >Cancel</button>
                </div>
            </div>
        )
    }
    function renderBody() {
        return (
            <div style={styles.bodyContainer}>
                <div style={styles.bodyInsideContainer}>
                    <div style={styles.contentContainer}>
                        {CLIENTTYPE.map((clientType, index) => (
                            <div key={index} style={styles.clientTypeItem}>
                                <button 
                                 style={currentSelectedClientTypes?.includes(clientType) ? styles.clientTypeItemCheckButtonActive : styles.clientTypeItemCheckButton}
                                 onClick={() => handleSelectButtonClick(index)}
                                 className={currentSelectedClientTypes?.includes(clientType) ? "check" : ""}
                                >
                               
                                </button>
                                <label htmlFor={`clientType-${index}`}>{clientType.name}</label>
                            </div>
                        ))}
                    </div>
                    
                </div>
            </div>
        )
    }
}

export function ValueWeightModal (props) {

    const {onClose, modalVisible, handleUpdateValueWeight, currentValue, title, setValueToUpdate, setValueSelected, valueSelected} = props

    const [styleTop, setStyleTop] = useState(null);
    const [styleLeft, setStyleLeft] = useState(null);
    const tipBtnRef = useRef(null);
    const modalTipRef = useRef(null);

    const [showTipModal, setShowTipModal] = useState(false)
    const [canContinue, setCanContinue ] = useState(false)

    const [thisValue, setThisValue] = useState(null)

    const [dragValueWeight, setDragValueWeight] = useState(currentValue?.weight/10)
    const containerRef = useRef(null);
    const [maxDragDistance, setMaxDragDistance] = useState(0);

    const [valueData, setValueData] = useState()

    useEffect(()=>{
        setDragValueWeight(currentValue?.weight/10)
    }, [currentValue])

    useEffect(() => {
        if (showTipModal && tipBtnRef.current && modalTipRef.current) {
            const btnRect = tipBtnRef.current.getBoundingClientRect();
    
            const modalTop = btnRect.top + window.scrollY - modalTipRef.current.offsetHeight - 4;
            const modalLeft = btnRect.left + window.scrollX - (modalTipRef.current.offsetWidth / 2) + (btnRect.width / 2);
    
            setStyleTop(modalTop);
            setStyleLeft(modalLeft);
        } else {
            setStyleTop(null);
            setStyleLeft(null);
        }
    }, [showTipModal, tipBtnRef, modalTipRef]);

    useEffect(() => {
        setThisValue(currentValue)
    },[currentValue])

    useEffect(()=> {
        setValueToUpdate({...thisValue, weight: dragValueWeight * 10})
    },[dragValueWeight])

    async function handleSaveButtonClicked() {
        setValueToUpdate(thisValue)
        setValueData(thisValue)
        let valueData = prepareValueWeightPayloadForUpdate(thisValue);
        if(valueData) {
            const params = valueData;
            await updateValueWeight(params).then((res) => {
                if(res) {
                    handleUpdateValueWeight()
                }
            });
        }
        
    }
    const prepareValueWeightPayloadForUpdate = (updatedValue) => {
        const valuePayloadForUpdate = {
            id : updatedValue.id,
            weight : updatedValue.weight,
        }
        return valuePayloadForUpdate
    }

    function handleCancelButtonClicked() {
        props.onClose()
    }

    useEffect(() => {
        // Calculate the width of the draggable container
        if (containerRef.current) {
          setMaxDragDistance(640);
        }
        else {setMaxDragDistance(640)}
      }, [containerRef.current]);


    const handleWeightChange = (event) => {
        if (maxDragDistance === 0) return; // Avoid division by zero

        const dragPosition = event.clientX - event.currentTarget.getBoundingClientRect().left; // Get the relative drag position (X-axis)

        // Scale the drag position to a value between 1 and 10
        const scaledValue = Math.min(10, Math.max(0, Math.floor((dragPosition / maxDragDistance) * 11)));

        setDragValueWeight(scaledValue);

        setCanContinue(true)
    };

    const styles = {
        modal: {
            display: "flex",
            flexDirection: "column",
            height: 216,
            bottom: "50%",
            top: "50%",
            padding: 0,
            borderRadius: 24,
            overflow: "hidden",
            width: 640,
            flexShrink: 0
        },
        modalWrapper: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
        },
        headerWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 24,
        },
        headerText: {
            color: "var(--Primary-Text, #374151)",

            /* Heading 6 */
            fontFamily: "Inter",
            fontSize: 24,
            fontStyle: "normal",
            fontWeight: 700
        },
        groupFlex : {
            display: "flex", 
            alignItems: "center"
        },
        nextButton :{
            borderRadius: 50,
            background: canContinue ? "var(--Primary, #F60)" : "var(--Stroke, #DFE4EA)",
            color: canContinue ? "#FFF" : "#9CA3AF",
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
        },
        cancelButton : {
            borderRadius: 50,
            border: "1px solid var(--Stroke, #DFE4EA)",
            background: "var(--White-White, #FFF)",
            marginLeft: 8,
            height : 40,
            width: 88
        },
        bodyContainer :  {
            borderRadius: 24,
            background: "var(--Gray-Gray-2, #F3F4F6)",
            padding: 8,
            width: 640,
            height: "100vh"
        },
        bodyInsideContainer : {
            background : "var(--White-White, #FFF)",
            borderRadius: 24,
            width: 624,
            height: "100%",
            padding: 16
        },
        valueWeightBase : {
            marginTop: 16,
            width: "100%",
            position: "relative",
            userSelect: "none",
            cursor: "pointer"
        },
        valueWeightEmpty : {
            width: "100%",
            height: 12,
            backgroundColor: "#D0F0FD",
            position: "absolute",
            top: -2,
            left: 0,
            borderRadius: "25px", // Round corners
        },
        valueWeight : {
            width: `${(dragValueWeight / 10) * 100}%`, // Fill the blue area based on the scaled value
            height: 8,
            backgroundColor: "var(--Cyan-Cyan, #01A9DB)",
            position: "absolute",
            top: 0,
            left: 0,
            borderRadius: "25px 0 0 25px", // Round corners on the left
        },
        circleMarker : {
            position: "absolute",
            top: -4, // Center vertically in the 50px height bar
            left: `calc(${(dragValueWeight / 10) * 100}%)`, // Center the circle relative to the drag value
            width: 16,
            height: 16,
            borderRadius: 16,
            border: "6px solid var(--Cyan-Cyan, #01A9DB)",
            background: "var(--Cyan-Cyan-light-3, #D0F0FD)",
            transform: "translateX(-50%)", // Ensure the marker is centered over the fill line
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
        },
        numberWeight : {
            display: "flex",
            justifyContent: "space-between",
            aligItems : "center",
            width: "100%",
            paddingTop: 16,
            fontSize: "16px",
        }
    }

    return (
        <>
        {showTipModal && 
            <ToolTipModal 
                headerText="Value Weighting"
                bodyText={
                    <>
                      Assigning weights for your values enables Intertru to prioritize candidates who align with the most important organizational value. 
                      If all values are equally important, assign the same weight to each.
                    </>
                }
                modalRef={modalTipRef} 
                buttonRef={tipBtnRef}
                styleTop={styleTop}
                styleLeft={styleLeft}
                showModalTip={setShowTipModal}
                modalType="valueweighttooltip"
            />
        }
        <Rodal
            visible={props.modalVisible}
            onClose={props.onClose}
            customStyles={{ ...styles.modal, ...props.style }}
            duration={0}
            showCloseButton={false}
        >
        <div style={styles.modalWrapper}>
            {renderHeader()}
            {renderBody()}
            
        </div>
        </Rodal>
        </>
    );

    function renderHeader() {
        return (
            <div style={styles.headerWrapper}>
                <div style={styles.groupFlex}>
                    <div style={styles.headerText}>{title}</div>
                    <button className="help-icon"
                        onMouseEnter={() => setShowTipModal(true)}
                        ref={tipBtnRef}
                    ></button>
                </div>
                <div style={styles.groupFlex}>
                    <button style={styles.nextButton}
                        onClick={() => handleSaveButtonClicked()}
                    >
                        {canContinue ? <div className="save-icon-active"></div> : <div className="save-icon-disable"></div>}
                        <div>Save</div>
                    </button>
                    <button style={styles.cancelButton}
                        onClick={() => handleCancelButtonClicked()}
                    >Cancel</button>
                </div>
            </div>
        )
    }
    function renderBody() {
        return (
            <div style={styles.bodyContainer}>
                <div style={styles.bodyInsideContainer}>
                    <div style={styles.itemTextTitle}>{`'${thisValue?.name ?? thisValue?.title}' - ${dragValueWeight}/10`}</div>
                    <div
                        ref={containerRef}
                        onClick={handleWeightChange}
                        style={styles.valueWeightBase}
                        >
                        <div
                            style={styles.valueWeightEmpty}
                        />
                        <div
                            style={styles.valueWeight}
                        />
                        <div
                            style={styles.circleMarker}
                        />

                        {/* Numbers 1 to 10 on top */}
                        <div
                            style={styles.numberWeight}
                        >
                            {Array.from({ length: 11 }, (_, i) => (
                            <span key={i}>{i}</span>
                            ))}
                        </div>
                        </div>
                </div>
            </div>
        )
    }
}

export function CompanySelection (props) {

    const {onClose, modalVisible} = props

    const navigate = useNavigate();
    const [companyLists, setCompanyLists] = useState()

    useEffect(() => {
        const fetchCompanies = async () => {
          try {
            const data = await listCompanies();
            setCompanyLists(data.items);
          } catch (error) {
            console.error('Error fetching company lists:', error);
          }
        };
    
        fetchCompanies();
      }, []);
 
    const styles = {
        modal: {
            display: "flex",
            flexDirection: "column",
            height: "auto",
            bottom: "auto",
            top: "auto",
            padding: 24,
            borderRadius: 24,
            overflow: "hidden",
            width: 896,
        },
        modalWrapper: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
            padding : 24
        },
        headerContainer :{
            display: "flex",
            justifyContent : "space-between",
        },
        headerText :{
            color: "var(--Primary-Text, #374151)",

            /* Heading 6 */
            fontFamily: "Inter",
            fontSize: 24,
            fontStyle: "normal",
            fontWeight: 700,
        },
        cancelButton :{
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            borderRadius: 50,
            background: "var(--White-White, #FFF)",
            border: "1px solid var(--Stroke, #DFE4EA)",
            width : 88,
            height: 40,
            color: "color: var(--Primary-Text, #374151)",
            textAlign: "center",

            /* Body Medium/Medium */
            fontFamily: "Inter",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 500
        },
        companyListsContainer : {
            display: "flex",
            flexDirection: "column",
            maxHeight: 400,
            overflow: "scroll",
            padding : 8,
            marginTop:16
        },
        companyButton : {
            display: "flex",
            padding: "8px 16px",
            justifyContent: "space-between",
            alignItems: "center",
            alignSelf: "stretch",
            width: "98%",        
            borderRadius: 16,
            background: "var(--Primary, #F60)",
            color: "white",
            marginBottom: 8
        }
    }

    const handleCompanySelected = (companyID, companyName) => {
        if(companyID) {
            props.onClose()
            navigate(`/admin/organizationprofile?compName=${companyName}&compId=${companyID}`);
        }
    }

    const handleCancelButtonClicked = () => {
        setCompanyLists(null)
        props.onClose()
    }

    return (
        <Rodal
            visible={modalVisible}
            onClose={onClose}
            customStyles={{ ...styles.modal, padding: 0 }}
            duration={0}
            showCloseButton={false}
        >
        <div style={styles.modalWrapper}>
            {renderHeader()}
            {renderBody()}
        </div>
        </Rodal>
    );

    function renderHeader() {
        return(
            <div style={styles.headerContainer}>
                <div style={styles.headerText}>Select Company</div>
                <button 
                    style={styles.cancelButton}
                    onClick={() => handleCancelButtonClicked()}
                >Cancel</button>
            </div>
        )
    }

    function renderBody(){
        return(
            <div style={styles.companyListsContainer}>
                {companyLists && companyLists?.sort((a, b)=>a?.company?.localeCompare(b?.company))?.map(companyData => (
                    <div key={companyData.id}>
                        <button
                            style={styles.companyButton}
                            onClick={() => handleCompanySelected(companyData.id, companyData.company)}>
                            <div>{companyData.company}</div>
                        </button>
                    </div>
                ))}
            </div>
        )
    }
}
